<template>
  <nav class="nav-sections home__nav-sections">
    <router-link
      v-for="page in pages"
      :key="page.path"
      :to="`/${page.path}`"
      :title="page.title"
      class="nav-sections__button"
      :class="page.class"
      active-class="_active"
    >
      <svg width="30" height="30">
        <use :xlink:href="page.icon" />
      </svg>
    </router-link>
  </nav>
</template>
<script>
export default {
  data() {
    return {
      pages: [
        { path: 'recent', title: 'Недавно открытые', icon: '#history' },
        { path: 'watchlist', title: 'На контроле', icon: '#flag' },
        { path: 'favorites', title: 'Избранное', icon: '#favorite' }
        // { path: 'services', title: 'Сервисы', icon: '#plus' },
        // { path: 'normacs.info', title: 'Последние обновления Normacs.info', icon: '#normacs-logo', class: '-normacs-button' },
        // { path: 'help', title: 'Помощь', icon: '#question-mark' }
      ]
    };
  }
};
</script>
